export const filterMaster = (call,data) => {
    let a = data.items.map((list) => {
      return { label: list.name, value: list.id };
    });
    call(a);
  };